import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "space-y-5" }
const _hoisted_2 = { class: "grid gap-3 sm:grid-cols-2" }
const _hoisted_3 = { class: "flex items-center gap-1" }
const _hoisted_4 = {
  key: 0,
  class: "flex flex-col gap-3"
}
const _hoisted_5 = { class: "flex flex-row items-center gap-2" }
const _hoisted_6 = { class: "text-xs font-bold" }
const _hoisted_7 = {
  key: 1,
  class: "text-muted-foreground text-xs"
}
const _hoisted_8 = {
  key: 2,
  class: "flex flex-col gap-3"
}
const _hoisted_9 = { class: "max-h-[300px] overflow-y-auto space-y-3" }
const _hoisted_10 = {
  key: 0,
  class: "pl-6 grid grid-cols-2 gap-2"
}
const _hoisted_11 = {
  key: 3,
  class: "text-muted-foreground text-xs"
}
const _hoisted_12 = {
  key: 4,
  class: "text-muted-foreground text-xs"
}

import { InputRow, Select, SectionHeader } from '@/components/ui/form';
    import { Input } from '@/components/ui/input';
    import { Label } from '@/components/ui/label';
    import { usePermissions } from '@/composables/usePermissions';
    import Permission from '@/enums/Permission';
    import FetchFromEconomicButton from '@/components/companies/FetchFromEconomicButton.vue';
    import { CheckboxGroupRoot, Separator, useFilter } from 'reka-ui';
    import { computed, ref } from 'vue';
    import { EconomicAccount, EconomicDimension } from '@/types';
    import SearchInput from '@/components/SearchInput.vue';
    import { Checkbox } from '@/components/ui/checkbox';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'CompanyEconomicForm',
  props: {
    form: {},
    voucherAccounts: { default: () => [] },
    isPendingVoucherAccounts: { type: Boolean },
    dimensions: { default: () => [] },
    isPendingDimensions: { type: Boolean }
  },
  emits: ["accounts-loaded"],
  setup(__props: any, { emit: __emit }) {

    const { hasPermission } = usePermissions();

    const props = __props;

    const emit = __emit;

    const handleAccountsLoaded = (accounts: EconomicAccount[]) => {
        emit('accounts-loaded', accounts);
    };

    const searchTerm = ref('');
    const { contains } = useFilter({ sensitivity: 'base' });

    const filteredVoucherAccounts = computed(() =>
        props.voucherAccounts.filter(
            (account: EconomicAccount) =>
                contains(account.name, searchTerm.value) ||
                contains(account.accountNumber.toString(), searchTerm.value),
        ),
    );

    const allSelected = computed({
        get: () => props.form.economic_accounts.length === props.voucherAccounts.length,
        set: () => toggleAll(),
    });

    const toggleAll = () => {
        props.form.economic_accounts = allSelected.value
            ? []
            : props.voucherAccounts.map((account: EconomicAccount) => account.id);
    };

    const getDimensionEnabled = (dimension: any) => {
        return dimension.is_enabled ?? false;
    };

    const setDimensionEnabled = (dimension: any, enabled: boolean | string) => {
        const isEnabled = Boolean(enabled);
        dimension.is_enabled = isEnabled;
        
        // Toggle all dimension values when dimension is toggled
        if (dimension.values && Array.isArray(dimension.values)) {
            dimension.values.forEach((value: any) => {
                value.is_enabled = isEnabled;
            });
        }
    };

    const getDimensionValueEnabled = (value: any) => {
        return value.is_enabled ?? false;
    };

    const setDimensionValueEnabled = (value: any, enabled: boolean | string) => {
        value.is_enabled = Boolean(enabled);
    };


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(SectionHeader), null, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t('companies.setup_tab_text')), 1)
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(InputRow), {
        form: _ctx.form,
        name: "endpoint",
        label: "companies.form.select"
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(Select), {
            modelValue: _ctx.form.endpoint,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.endpoint) = $event)),
            options: [
                        { value: 'plain', label: 'companies.plain_account' },
                        { value: 'economic', label: 'companies.economic_account' },
                    ],
            translate: true
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }, 8, ["form"]),
      _createVNode(_unref(InputRow), {
        form: _ctx.form,
        name: "api_token",
        label: "companies.api_token"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_unref(Input), {
              id: "api_token",
              modelValue: _ctx.form.api_token,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.api_token) = $event)),
              autocomplete: "api_token",
              placeholder: _ctx.$t('companies.api_token')
            }, null, 8, ["modelValue", "placeholder"]),
            (_unref(hasPermission)(_unref(Permission).COMPANIES_UPDATE))
              ? (_openBlock(), _createBlock(FetchFromEconomicButton, {
                  key: 0,
                  form: _ctx.form,
                  onAccountsLoaded: handleAccountsLoaded
                }, null, 8, ["form"]))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      }, 8, ["form"]),
      _createVNode(_unref(InputRow), {
        form: _ctx.form,
        name: "economic_number",
        label: "companies.form.economic_number"
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(Input), {
            id: "economic_number",
            modelValue: _ctx.form.economic_number,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.economic_number) = $event)),
            autocomplete: "economic_number",
            placeholder: _ctx.$t('companies.form.economic_number'),
            readonly: ""
          }, null, 8, ["modelValue", "placeholder"])
        ]),
        _: 1
      }, 8, ["form"]),
      _createVNode(_unref(InputRow), {
        form: _ctx.form,
        name: "website",
        label: "companies.form.website"
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(Input), {
            id: "website",
            modelValue: _ctx.form.website,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.website) = $event)),
            autocomplete: "website",
            placeholder: _ctx.$t('companies.form.website')
          }, null, 8, ["modelValue", "placeholder"])
        ]),
        _: 1
      }, 8, ["form"])
    ]),
    _createVNode(_unref(SectionHeader), null, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t('companies.accounts')), 1)
      ]),
      _: 1
    }),
    (_ctx.voucherAccounts.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode(SearchInput, {
            placeholder: _ctx.$t('forms.search'),
            modelValue: searchTerm.value,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((searchTerm).value = $event))
          }, null, 8, ["placeholder", "modelValue"]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_unref(Label), { class: "flex flex-row items-center gap-2 font-normal" }, {
              default: _withCtx(() => [
                _createVNode(_unref(Checkbox), {
                  modelValue: allSelected.value,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((allSelected).value = $event))
                }, null, 8, ["modelValue"]),
                _createElementVNode("span", null, _toDisplayString(allSelected.value ? _ctx.$t('forms.unselect_all') : _ctx.$t('forms.select_all')), 1)
              ]),
              _: 1
            }),
            _createVNode(_unref(Separator), {
              orientation: "vertical",
              class: "h-2.5!"
            }),
            _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.form.economic_accounts.length) + " " + _toDisplayString(_ctx.$t('forms.selected_options')), 1)
          ]),
          _createVNode(_unref(CheckboxGroupRoot), {
            modelValue: _ctx.form.economic_accounts,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.economic_accounts) = $event)),
            class: "grid max-h-[300px] grid-cols-2 gap-2 overflow-y-auto"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredVoucherAccounts.value, (account) => {
                return (_openBlock(), _createBlock(_unref(Label), {
                  key: account.id,
                  class: "flex flex-row items-center gap-2 font-normal"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(Checkbox), {
                      value: account.id
                    }, null, 8, ["value"]),
                    _createElementVNode("span", null, _toDisplayString(account.accountNumber) + " - " + _toDisplayString(account.name), 1)
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.$t('companies.no_voucher_accounts')), 1)),
    _createVNode(_unref(SectionHeader), null, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t('companies.dimensions')), 1)
      ]),
      _: 1
    }),
    (_ctx.form.economic_dimensions && _ctx.form.economic_dimensions.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.form.economic_dimensions, (dimension, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: dimension.id,
                class: _normalizeClass(["space-y-2", { 'pb-3 border-b border-border/50': Number(index) < _ctx.form.economic_dimensions.length - 1 }])
              }, [
                _createVNode(_unref(Label), { class: "flex flex-row items-center gap-2 font-normal" }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(Checkbox), {
                      "model-value": getDimensionEnabled(dimension),
                      "onUpdate:modelValue": ($event: any) => (setDimensionEnabled(dimension, $event))
                    }, null, 8, ["model-value", "onUpdate:modelValue"]),
                    _createElementVNode("span", null, _toDisplayString(dimension.name), 1)
                  ]),
                  _: 2
                }, 1024),
                (dimension.values && dimension.values.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dimension.values, (value) => {
                        return (_openBlock(), _createBlock(_unref(Label), {
                          key: value.id,
                          class: "flex flex-row items-center gap-2 font-normal"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(Checkbox), {
                              "model-value": getDimensionValueEnabled(value),
                              "onUpdate:modelValue": ($event: any) => (setDimensionValueEnabled(value, $event))
                            }, null, 8, ["model-value", "onUpdate:modelValue"]),
                            _createElementVNode("span", null, _toDisplayString(value.key) + " - " + _toDisplayString(value.name), 1)
                          ]),
                          _: 2
                        }, 1024))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true)
              ], 2))
            }), 128))
          ])
        ]))
      : (_ctx.isPendingDimensions)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(_ctx.$t('companies.loading_dimensions')), 1))
        : (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(_ctx.$t('companies.no_dimensions')), 1))
  ]))
}
}

})